module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.layout === 'LISTA') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [(!_vm.ehVisualizacao) ? _c('div', {
    staticClass: "box-body"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo documento")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {}, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), _c('td', [_vm._v("Vigência")]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
    return (_vm._.get(documento, 'mostrar', true)) ? _c('tr', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('td', [_vm._v("\n                " + _vm._s(documento.tipo_documento.ds_tipo) + "\n                "), (_vm._.has(documento, 'ds_tipo_usuario') && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          placement: 'top',
          animation: 'perspective',
          distance: '1',
          size: 'large'
        }),
        expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
      }],
      staticStyle: {
        "color": "var(--cor-destaque)",
        "font-size": "10px",
        "margin-left": "15px"
      },
      attrs: {
        "title": '<h5>' + documento.ds_nome_usuario + '</h5>'
      }
    }, [_vm._v("\n                " + _vm._s(documento.ds_tipo_usuario) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "ng-binding",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.onDownload(documento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm._f("moment")(documento.dt_data_validade, 'DD/MM/YYYY')) + "\n                "), (_vm.idsVerificaVencimento && !_vm._.isNull(_vm.idsVerificaVencimento) && (_vm.idsVerificaVencimento.length === 0 || _vm._.includes(_vm.idsVerificaVencimento, _vm._.get(documento, 'tipo_documento.id', 0)))) ? _c('span', [(!_vm._.isEmpty(documento.dt_data_validade) && ((new Date(documento.dt_data_validade) - new Date()) / 86400000) < -1) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("vencido")]) : (!_vm._.isEmpty(documento.dt_data_validade) && ((new Date(documento.dt_data_validade) - new Date()) / 86400000) < 0) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("vencendo")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('td', [(!_vm.ehVisualizacao) ? _c('button', {
      directives: [{
        name: "confirm",
        rawName: "v-confirm",
        value: ({
          ok: function (retorno) { return _vm.deletaDocumento(indexDocumento, documento); },
          cancel: _vm.doNothing,
          message: ("Deseja <b>excluir</b> o documento " + (documento.ds_nome_arquivo) + "? Essa ação é irreversível.")
        }),
        expression: "{ok: retorno => deletaDocumento(indexDocumento, documento), cancel: doNothing,\n                           message: `Deseja <b>excluir</b> o documento ${documento.ds_nome_arquivo}? Essa ação é irreversível.`}"
      }],
      staticClass: "btn btn-danger btn-sm btn-flat",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")]) : _vm._e()]) : _vm._e()]) : _vm._e()
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['EDICAO'], _vm.layout)) ? _c('div', {
    staticClass: "form-group well"
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('uploadArquivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        size: _vm.tamanhoPermitido,
        mimes: _vm.tiposPermitidos
      }),
      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
    }],
    ref: "file",
    attrs: {
      "type": "file",
      "name": "uploadArquivo",
      "id": "file"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })]), _vm._v(" "), (_vm.errors.first('uploadArquivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Selecione um arquivo")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('uploadTipoDocumento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "uploadTipoDocumento"
    }
  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), (_vm.loading.usosDocumento) ? _c('div', {
    staticClass: "col-md-4 etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando tipos de documentos disponíveis ...")]) : _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documento.tipo_documento),
      expression: "documento.tipo_documento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "uploadTipoDocumento",
      "id": "uploadTipoDocumento"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, _vm._l((_vm.documentos), function(documento) {
    return _c('option', {
      domProps: {
        "value": documento
      }
    }, [_vm._v(_vm._s(documento.ds_tipo))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('uploadTipoDocumento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve classificar o documento em um dos tipos da lista")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: _vm._.includes(_vm.idsVigenciaObrigatoria, _vm._.get(_vm.documento, 'tipo_documento.id', 0)) ? ('required-field ' + (_vm.errors.first('uploadDataVigencia') ? 'has-error' : '')) : ''
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm._.includes(_vm.idsVigenciaObrigatoria, _vm._.get(_vm.documento, 'tipo_documento.id', 0)) ? 'required' : ''),
      expression: "_.includes(idsVigenciaObrigatoria, _.get(documento, 'tipo_documento.id', 0)) ? 'required' : ''"
    }],
    attrs: {
      "input-class": "form-control datepicker",
      "id": "uploadDataVigencia",
      "name": "uploadDataVigencia",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.documento.dt_data_validade),
      callback: function($$v) {
        _vm.$set(_vm.documento, "dt_data_validade", $$v)
      },
      expression: "documento.dt_data_validade"
    }
  }), _vm._v(" "), (_vm._.has(_vm.documento, 'dt_data_validade')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, placement:'right', animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "input-group-btn",
    attrs: {
      "title": '<h5>Limpar essa data</h5>'
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "white",
      "border-color": "rgb(210, 214, 222)",
      "border-width": "1px 0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm._.unset(_vm.documento, 'dt_data_validade');
        _vm.$forceUpdate()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('uploadDataVigencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Para este tipo de documento é obrigatório informar a data que expira sua validade")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && _vm._.has(_vm.documento, 'tipo_documento') && _vm._.has(_vm.documento, 'file') &&
    !_vm._.find(_vm.errors.items, function(e) {
      return _vm._.includes(['uploadArquivo', 'uploadDataVigencia', 'uploadTipoDocumento'], e.field)
    }) &&
    (!_vm._.includes(_vm.idsVigenciaObrigatoria, _vm._.get(_vm.documento, 'tipo_documento.id', 0)) || (_vm._.has(_vm.documento, 'dt_data_validade') && _vm._.includes(_vm.idsVigenciaObrigatoria, _vm._.get(_vm.documento, 'tipo_documento.id', 0))))) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionaDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        return _vm.cancela($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.adicionando || _vm.loading.alterando || _vm.loading.excluindo),
      expression: "loading.adicionando || loading.alterando || loading.excluindo"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cf72493c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/articulacao/UploadDocumentosOnline.vue
// module id = 1956
// module chunks = 2